import { footerColumns, footerDisclaimer } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-100">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6 md:py-14">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-cake-2-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">91吃瓜</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">{footerDisclaimer}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-secondary-200 bg-background-50 px-3 py-1 text-xs text-foreground-600">
              <i className="ri-shield-check-line text-accent-600" />仅入口指引
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-secondary-200 bg-background-50 px-3 py-1 text-xs text-foreground-600">
              <i className="ri-refresh-line text-primary-500" />地址持续更新
            </span>
          </div>
        </div>

        {footerColumns.map((column) => (
          <div key={column.title}>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="#top" className="transition-colors hover:text-primary-600">
                {column.title}
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {column.links.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-500 sm:flex-row md:px-6">
          <span>© 2026 91吃瓜 · 本站仅整理公开入口信息，不存储任何内容。</span>
          <span className="whitespace-nowrap">页面所示地址与数据仅作演示用途</span>
        </div>
      </div>
    </footer>
  );
}